module.exports = __webpack_public_path__ + "img/retailers.2ace038d.gif";